import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';

type Lang = 'ar' | 'en';

interface ValueItem {
  icon: string;
  title: string;
  text: string;
}

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, OnDestroy {
  
  language: Lang = 'en';
  AboutHospital = '';
  isLoading$: Observable<boolean>;

  values: ValueItem[] = [];
  HistoryValues: any[] = [];
current = 0;

  private readonly destroy$ = new Subject<void>();
  private aboutAr = '';
  private aboutEn = '';

  constructor(
    private readonly hospitalService: HospitalService,
    private readonly translationService: TranslationService
  ) {}
  select(i: number) {
    this.current = i;
  }

  prev() {
    this.current = (this.current - 1 + this.HistoryValues.length) % this.HistoryValues.length;
  }

  next() {
    this.current = (this.current + 1) % this.HistoryValues.length;
  }
  ngOnInit(): void {
    // 1) language
    const lang = this.translationService.getSelectedLanguage() as Lang;
    this.setLanguage(lang);

    // (optional) If your TranslationService exposes a language stream,
    // uncomment this to react to live language changes:
    // this.translationService.languageChanged$
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((l: Lang) => this.setLanguage(l));

    // 2) data
    this.isLoading$ = this.hospitalService.isLoading$;

    this.hospitalService.GetHospitalContacts()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res?.isSuccess && res.data) {
          this.aboutAr = res.data.aboutAr ?? '';
          this.aboutEn = res.data.aboutEn ?? '';
          this.updateAboutText();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // --- UI actions ---
  get isRTL(): boolean {
    return this.language === 'ar';
  }

  scroll(track: HTMLElement, dir: number): void {
    const card = track.querySelector<HTMLElement>('.bm-card');
    const gap = 24;
    const step = (card?.offsetWidth || track.clientWidth * 0.8) + gap;
    const delta = this.isRTL ? -dir * step : dir * step;
    track.scrollBy({ left: delta, behavior: 'smooth' });
  }

  // --- helpers ---
  private setLanguage(lang: Lang): void {
    this.language = lang;
    this.values = this.buildValues(lang);
    this.HistoryValues = this.buildHistoryValues(lang);
    this.updateAboutText();
  }

  private updateAboutText(): void {
    this.AboutHospital = this.language === 'ar' ? this.aboutAr : this.aboutEn;
  }

  private buildValues(lang: Lang): ValueItem[] {
    const ar = lang === 'ar';
    return [
      {
        icon: 'assets/icons/care.svg',
        title: ar ? ' تمكين قيادات وحدات الأعمال' : 'Empower business units` leaderships  ',
        text: ar
          ? 'من اتخاذ القرارات التشـــــــــــــــغيلية بناءً على الخطط والميزانيات المعتمدة'
          : 'in operational decision-making based on approved business plans and budgets (Post to Reform).'
      },
      {
        icon: 'assets/icons/trust.svg',
        title: ar ? 'تبسيط الخدمات المشتركة ' : 'Streamlined shared services',
        text: ar
          ? 'لتحقيق  النمو الاقتصادي.'
          : 'to capture economies of scale.'
      },
      {
        icon: 'assets/icons/excellence.svg',
        title: ar ? 'حوكمة قوية، وتقارير دقيقة' : 'Robust governance, reporting',
        text: ar
          ? 'ومؤشــــــــــــرات أداء رئيســية لضمان الرقابة والإشراف.'
          : 'and KPIs to maintain oversight.'
      },
       {
        icon: 'assets/icons/excellence.svg',
        title: ar ? 'مواءمة الحوافز والأهداف ' : 'Alignment of incentives and goals ',
        text: ar
          ? 'عبر المنظمة لتوحيد الأهداف علــى جميع المستويات.'
          : 'across the organization to unify goals across the levels .'
      },
       {
        icon: 'assets/icons/excellence.svg',
        title: ar ? 'الاستفادة من التكنولوجيا ' : 'Leveraging technology ',
        text: ar
          ? 'لتعزيز التكامل واتخاذ القرارات المستندة إلى البيانات.'
          : 'to enhance integration and data-driven decision-making.'
      },
       {
        icon: 'assets/icons/excellence.svg',
        title: ar ? 'تحديد واستقطاب ' : 'Identify and acquire  ',
        text: ar
          ? 'مقدمي الرعاية الصحية الواعدين الذين يتمتعـــــــــــون بإمكانيات مضافة للقيمة.'
          : 'acquire promising healthcare providers with value-add potential.'
      },
       {
        icon: 'assets/icons/excellence.svg',
        title: ar ? 'تنفيذ أفضل الممارسات التشغيلية ' : 'Implement best-in-class operational practices ',
        text: ar
          ? 'التشغيلية والخدمات المشتركة في القطاع لتعزيز الكفاءة والربحية في جميع مجموعة الاستثمارات.'
          : 'and shared services to drive efficiency and profitability across the portfolio.'
      },
      {
        icon: 'assets/icons/excellence.svg',
        title: ar ? 'تزويد مجموعة استثماراتنا ' : 'Provide our portfolio companies ',
        text: ar
          ? 'استثماراتنا بالموارد والخبرات والاســــــــــــتقلالية اللازمة لتقديم رعاية استثنائية للمرضى.'
          : 'with the resources, expertise, and autonomy they need to deliver exceptional patient care.'
      },
       {
        icon: 'assets/icons/excellence.svg',
        title: ar ? 'تحقيق العوائد طويلة ' : 'Maximize long-term returns  ',
        text: ar
          ? 'لشركائنا من خلال استراتيجيات استثمار منضبطة وإدارة نشطة لمجموعة الاستثمارات.'
          : 'for our investors through disciplined investment strategies and active portfolio management.'
      }
    ];
  }
  private buildHistoryValues(lang: Lang): any[] {
    const ar = lang === 'ar';
    return [
      {
         year: 1984,
         image: 'assets/img/History/01.jpg',
          title:  ar ? 'البداية من الخفجي' : 'The Beginning in Khafji',
          desc:  ar ? 'في مدينة الخفجي، وعلى أرضٍ تطل على الخليج العربي، وُلدت أول لبنة لما سيصبح لاحقًا "بلسم" .  تأسست تحت اسم مستوصف الخفجي الأهلي. ' :
          'In the city of Khafji, overlooking the Arabian Gulf, the first foundation stone of what would later become Balsam was laid, under the name Al-Khafji National Clinic. ',
      },
      {
         year: 1987,
         image: 'assets/img/History/02.jpg',
          title:  ar ? 'أول تحول' : 'The First Transformation',
          desc:  ar ? 'بعد ثلاث سنوات فقط، توسع نشاط المنشأة لتقدم خدمات المستشفيات.' :
          "Just three years later, the facility expanded its operations to provide full hospital services. ",
      },
      {
         year: 2021,
         image: 'assets/img/History/06.jpg',
          title:  ar ? 'التقاء المسارات وبداية منظومة استثمارية' : 'Converging Paths and the Birth of an Investment Ecosystem',
          desc:  ar ? 'في خطوة استراتيجية، اجتمعت خمس شركات صحية متنوعة من انحاء المملكة  لتشكّل نواة كيان موحد. وبعد عقود من النمو المتواصل بتحويل المنشأة إلى شركة مساهمة مقفلة تأكيداً على جاهزيتها لمرحلة جديدة.' :
          "In a strategic move, five healthcare companies from across the Kingdom united to form the nucleus of a unified entity. After decades of continuous growth, the organization transformed into a closed joint-stock company, ready for a new phase of expansion.",
      },
      {
         year: 2023,
         image: 'assets/img/History/03.jpg',
          title:  ar ? 'ولادة الاسم وأول استحواذ' : 'The Birth of the Name and First Acquisition',
          desc:  ar ? 'اكتملت الهوية، وتحوّل الاسم رسميًا إلى بلسم للرعاية الطبية، واتخذت الشركة من الرياض مقرًا لها.   واستحوذت بلسم على "عيادتكم الطبية" بالرياض، في خطوة تؤكد قدرتها على النمو الذكي، واختيار الفرص التي تُحدث فرقاً.' :
          "The identity was completed, and the company officially became Balsam Medical Care, headquartered in Riyadh. Balsam acquired Your Clinics Medical Center in Riyadh — a move that demonstrated its ability to grow intelligently and seize opportunities that make a difference.",
      },
      {
         year: 2024,
         image: 'assets/img/History/04.jpg',
          title:  ar ? 'نحو الحوكمة والاحترافية والتوسع المدروس' : 'Advancing Governance, Professionalism, and Strategic Growth',
          desc:  ar ? 'انطلقت بلسم مرحلة أكثر نضجاً، ارتكزت على تطبيق مبادئ الحوكمة وتعزيز كفاءة الإدارة لضمان استدامة النمو. ' :
          "Balsam entered a more mature phase focused on implementing governance principles and enhancing management efficiency to ensure sustainable growth. ",
      },
      {
         year: 2025,
         image: 'assets/img/History/05.jpg',
          title:  ar ? 'نحو منظومة صحية متكاملة' : 'Towards an Integrated Healthcare Ecosystem ',
          desc:  ar ? 'في خطوة تعكس توجهاً استراتيجياً نحو بناء منظومةٍ صحيةٍ متكاملة تجمع بين الخدمة والتقنية والابتكار، استحوذ مستثمرو بلسم على حصة الأغلبية في أحد المصانع الطبية القائمة، دعما لتوجههم في تعزيز التكامل الصناعي ونمو الإيرادات المستدامة.' :
          "In a strategic step toward building a comprehensive healthcare system that combines service, technology, and innovation, Balsam investors acquired a majority stake in an existing medical factory — reinforcing industrial integration and supporting sustainable revenue growth.",
      },
      {
         year: 2026,
         image: 'assets/img/History/07.jpg',
          title:  ar ? 'استحواذ مستشفى سلامات' : 'Salamat Hospital Acquisition',
          desc:  ar ? 'في إطار استراتيجية مجموعة بلسم للرعاية الطبية للتوسع وتعزيز خدمات الرعاية الصحية، تم الاستحواذ على مستشفى سلامات خلال عام 2026. ويأتي هذا الاستحواذ ضمن جهود المجموعة لتوسيع نطاق خدماتها الصحية، ورفع جودة الرعاية المقدمة، وتعزيز حضورها في مختلف مناطق المملكة، بما يسهم في تقديم خدمات طبية متكاملة تلبي احتياجات المرضى والمجتمع.' :
          'As part of Balsam Medical Care Group\'s strategic expansion and commitment to enhancing healthcare services, Salamat Hospital was acquired in 2026. This acquisition reflects the Group\'s ongoing efforts to expand its healthcare network, improve the quality of care, and strengthen its presence across the Kingdom, enabling the delivery of comprehensive healthcare services that meet the needs of patients and communities.',
      },
    ];
  }
}
